
export default {
  name: 'ProductShortcut',

  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
    align: {
      type: String, // options: default ''(left) / 'center' / 'right'
      required: false,
      default: '',
    }
  },
  data() {
    return {
      currentLocale: this.$i18n.locale
    }
  },
  mounted() {
    // console.log('ProductShortcut', this.data)
  },
  computed: {
    getAlignment() {
      if (this.align) return `align-${this.align}`;
      return '';
    },
    showShortcut() {
      return !Object.values(this.data).every(value => value === false);
    },
    isFulfilmentRatioProduct() {
      if (Object.keys(this.data)[0].includes('saving') || Object.keys(this.data)[0].includes('annuity')) {
        return true;
      }
      return false;
    },
    herf() {
      if (this.isFulfilmentRatioProduct) {
        return `/${this.currentLocale}/scoring-methodology/stable-fulfillment-ratio-insurer`;
      }
      return `/${this.currentLocale}/happy-kids-2024`;
    },
    imgSrc() {
      if (this.isFulfilmentRatioProduct) {
        return require('@/assets/images/five-star/fulfilment-ratio-tag.svg');
      }
      return require("@/assets/images/products/product-feature/campaign-icons/happy-kid.svg");
    },
    imgAlt() {
      if (this.isFulfilmentRatioProduct) {
        return this.$t('productShortcut.fulfilmentRatio');
      }
      return this.$t('productShortcut.happyKids');
    },
    text() {
      if (this.isFulfilmentRatioProduct) {
        return this.$t('productShortcut.fulfilmentRatio');
      }
      return this.$t('productShortcut.happyKids');
    }
  }
};
